import * as React from 'react';
import Icons from "../../Icons";
import {renderAlert} from "../../RenderCommon";
import Modal from "react-responsive-modal";

interface DevaliderFichiersClientProps {
  onOpenModalDevaliderFichiersByClient: () => void;
  onCloseModalDevaliderFichiersByClient: () => void;
  textDevaliderFichierByClient: string;
  classAlert: string;
  openDevaliderFichiersByClient: boolean;
  _devaliderFichier: (event: React.MouseEvent<HTMLButtonElement>, isByClient: boolean) => void;
}

export const DevaliderFichiersClient = (props: DevaliderFichiersClientProps) => {
  return (
    <>
      <div>
        <div onClick={() => { props.onOpenModalDevaliderFichiersByClient(); }}
             className={`d-flex text-center justify-content-center`}>
          <div>
            <button className={`mt-2 devaliderFichierBtn font16 btnBatAuto bg-grey cursor-pointer  d-flex align-items-center justify-content-center cursor-pointer  lineheight1 buttonPrimary text-center p-4 `}>
              <Icons icon="ic-revert" size={20} color="grey" className="mr-2"/>  Envoyer de nouveaux fichiers
            </button>
          </div>
        </div>
      </div>
      {props.textDevaliderFichierByClient !== '' &&
        renderAlert(true, props.classAlert + ' justify-content-center',
          props.textDevaliderFichierByClient)
      }
      <Modal open={props.openDevaliderFichiersByClient} onClose={props.onCloseModalDevaliderFichiersByClient} center
             classNames={{overlay: 'bootstrap-container', modal: ' customModal',
               closeButton: ' closeButton'}}>
        <div className="p-2">
          <p className={'text-center font18 bold'}>Dévalider mes fichiers</p>
          <p className={'text-center font18'}>Êtes vous sûr de vouloir envoyer de nouveaux fichiers ?</p>
          <button title="Annuler" onClick={props.onCloseModalDevaliderFichiersByClient}
                  className="border border-dark bold bg-white cursor-pointer btnCancelModal  py-2 px-3 float-left">
            <Icons icon="cancel" size={30} color="black" className="mr-2"/> Annuler
          </button>
          <button title="Valider" onClick={(event) => { props._devaliderFichier(event, true); }}
                  className={'border border-dark bold bg-white ml-0 ml-md-5 cursor-pointer btnValidateModal py-2 px-3 float-right'}>
            <Icons icon="check_circle" size={30} color="black" className="mr-2"/> Confirmer
          </button>
        </div>
      </Modal>
    </>
  )
}
